import * as types from '@/store/types'
export default {
    events: state => {
        return state.events
    },
    modelDefault: state => {
        return state.modelDefault
    },
    getEventsForPosts: state => {
        return state.events.filter(event => event.event === 'wall_reply_new')
    }
}
